angular.module('picmonicng').component('homeDigitalDownloads', {
  templateUrl: '/templates/app/components/home-digital-downloads/home-digital-downloads.html',
  bindings: {},
  replace: true,
  controller: [
    'UserService',
    function (UserService) {
      var $ctrl = this;

      $ctrl.UserService = UserService;

      $ctrl.downloads = [
        {
          thumbnail: 'bundle1.png',
          url: 'https://shop.picmonic.com/collections/digital-downloads/products/picmonics-complete-nursing-school-study-bundle-digital-download-4-weeks-to-nclex-workbook-study-planner-70-cheat-sheets-for-nursing-school-2021-2022-nursing-student-planner',
          title: "Picmonic's Complete Nursing School Study Bundle",
          description:
            '4 Weeks to NCLEX® Workbook & Study Planner, 70 Cheat Sheets for Nursing School, 2021-2022 Nursing Student Planner',
          strike_price: 119.97,
          sale_price: 24.0,
          primary: 1,
        },
        {
          thumbnail: 'clinicals1.jpg',
          url: 'https://shop.picmonic.com/collections/digital-downloads/products/critical-clinicals-70-cheat-sheets-for-nursing-school-nclex%C2%AE-studying-and-new-grads',
          title: '',
          description: 'Critical Clinicals: 70 Cheat Sheets for Nursing School, NCLEX® Studying, and New Grads',
          strike_price: 39.99,
          sale_price: 15.0,
          primary: 0,
        },
        {
          thumbnail: 'nclex1.jpg',
          url: 'https://shop.picmonic.com/collections/digital-downloads/products/4-weeks-to-nclex%C2%AE-workbook-study-planner-digital-download-nursing-mnemonic-visual-learning-resource-by-picmonic',
          title: '',
          description: '4 Weeks to NCLEX® Workbook & Study Planner',
          strike_price: 39.99,
          sale_price: 15.0,
          primary: 0,
        },
        {
          thumbnail: 'planner1.jpg',
          url: 'https://shop.picmonic.com/collections/digital-downloads/products/2021-monthly-weekly-nursing-student-calendar-goal-organizer-to-do-list-and-planner-digital-download-by-picmonic',
          title: '',
          description: '2021-2022 Monthly & Weekly Nursing Student Calendar, Goal Organizer, To-Do List and Planner',
          strike_price: 39.99,
          sale_price: 15.0,
          primary: 0,
        },
      ];

      $ctrl.openDownload = function (download) {
        window.open(download.url, '_blank');
      };
    },
  ],
});
